export default __webpack_public_path__ + "static/media/imageC4.4e81c1c2.png";